import { render, staticRenderFns } from "./CalendarFeedSection.vue?vue&type=template&id=5059490d&scoped=true"
import script from "./CalendarFeedSection.vue?vue&type=script&lang=js"
export * from "./CalendarFeedSection.vue?vue&type=script&lang=js"
import style0 from "./CalendarFeedSection.vue?vue&type=style&index=0&id=5059490d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5059490d",
  null
  
)

export default component.exports